export const faqData = [
  {
    id: "01",
    question:
      "How much does SEO cost and how do you determine pricing?",
    answer:
      "Pricing is determined by your competitive landscape, target keywords, and the complexity of your website. Our monthly packages start from a competitive price of $180 per month for local businesses, but the exact investment is tailored to meet your unique ROI goals and the level of service required.",
  },
  {
    id: "02",
    question: "How long does it take to get results from SEO? ",
    answer:
      "SEO is a long-term investment. While technical improvements and on-page fixes can yield initial results in 60-90 days, significant, tangible growth and high-volume keyword rankings typically begin around the 6-9 month mark and continue to build thereafter.",
  },
  {
    id: "03",
    question: "How can I measure my SEO's ROI?",
    answer:
      "We measure ROI by correlating organic traffic growth and keyword ranking improvements, in Google Analytics, directly to your conversion data (leads, sales and phone calls). We focus on the monetary value generated by organic search versus the cost of our services. ",
  },
 
  {
    id: "04",
    question: "What is the potential of SEO in Great Falls, VA particularly? ",
    answer:
      "The potential is exceptionally high. Great Falls is an affluent market with a median household income exceeding $250,000. Key industries here are high-value and demand highly targeted, authoritative online visibility. By optimizing for this local market, you attract customers with high purchasing power and high intent, making every interaction extremely valuable.",
  },
  {
    id: "05",
    question: "Can we work with and improve your existing website?",
    answer:
      "Absolutely. We can easily improve any website, regardless of the platform or current ranking. We diagnose and fix all technical and content issues on existing websites.",
  },
  
];